import React, { useEffect, useMemo } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes as RouterRoutes,
} from 'react-router';
import {
  adminRoutes,
  memberRoutes,
  NotificationEntityType,
  Routes,
  superAdminRoutes,
} from 'types';
import './MainRouter.scss';
import { Layout } from '../layout/Layout';
import { LoginPage } from 'app/pages/login';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { useAuth } from 'app/shared/providers';
import { useProfileApi } from '../../hooks';
import { RouterMiddleware } from './RouterMiddleware';
import LoginWrapper from 'app/pages/login/LoginWrapper';

export const MainRouter = () => {
  const {
    isReady,
    isAuthenticated,
    supplierId,
    isAdmin,
    isSuperAdmin,
    isMember,
  } = useAuth();
  const { fetchProfile } = useProfileApi({});

  const userRoutes = useMemo(() => {
    return isSuperAdmin
      ? superAdminRoutes
      : isAdmin
      ? adminRoutes
      : !isSuperAdmin && !isAdmin && isMember
      ? memberRoutes
      : [];
  }, [isAdmin, isMember, isSuperAdmin]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchProfile();
    }
  }, [isAuthenticated, fetchProfile]);

  return isReady ? (
    <BrowserRouter>
      <RouterMiddleware>
        <AuthenticatedTemplate>
          <RouterRoutes>
            {userRoutes.map((route, index) => {
              if (!route?.redirect) {
                return (
                  <Route
                    key={index}
                    path={route.path || '*'}
                    element={
                      // Keyed so each route remounts its Layout, as v5's <Switch> did.
                      <Layout
                        key={index}
                        withSideNavigation={route.path !== Routes.Not_Found}
                      >
                        <route.component />
                      </Layout>
                    }
                  />
                );
              } else {
                return (
                  <Route
                    key={index}
                    path={Routes.Home}
                    element={
                      <Navigate
                        replace
                        to={
                          route.redirect === Routes.Organizations
                            ? route.redirect
                            : route.redirect
                                .replace(':organizationId', supplierId)
                                .replace(
                                  ':entityType',
                                  NotificationEntityType.PROJECT.toString(),
                                )
                        }
                      />
                    }
                  />
                );
              }
            })}
          </RouterRoutes>
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <RouterRoutes>
            <Route
              path={Routes.Home}
              element={<Navigate replace to={Routes.Login} />}
            />

            <Route path={Routes.Login} element={<LoginPage />} />

            <Route
              path="*"
              element={
                <LoginWrapper>
                  <LoginPage />
                </LoginWrapper>
              }
            />
          </RouterRoutes>
        </UnauthenticatedTemplate>
      </RouterMiddleware>
    </BrowserRouter>
  ) : null;
};
